import styled from 'styled-components';
import { colours, fonts } from 'themes/default';
import { LinkButton, CancelButton } from 'components/ui/Button';
import { AlertTriangle } from 'react-feather';
import { Form } from 'components/ui/Form';

export const DetailsContainer = styled.div`
  margin: 1px 0 10px 0;
  width: inherit;
  box-shadow: 0px 0px 30px ${colours.Greyscale.SilverGrey};
`;
export const EditContainer = styled.div`
  padding-left: 10px;
`;

export const ExitButton = styled(CancelButton)`
  text-align: center;
  margin-left: 10px;
  width: 100px;
`;

export const StyledLinkButton = styled(LinkButton)``;

export const StyledForm = styled(Form)`
  padding: 16px;
  // background-color: ${colours.Greyscale.White};
  width: inherit;
  box-shadow: 0px 0px 30px ${colours.Greyscale.SilverGrey};
  margin-bottom: 15px;
`;

export const StyledTextArea = styled.textarea`
  display: block;
  box-sizing: border-box;
  border-radius: 5px;
  width: 100%;
  height: 150px;
  resize: none;
`;

export const StyledAlertTriangle = styled(AlertTriangle)`
  color: ${colours.Shades.BlueShade40};
  margin-right: 5px;
  margin-left: 20px;
  margin-bottom: 2px;
`;

export const Content = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: nowrap;
`;

export const RemarkContent = styled.p`
  font-size: ${fonts.fontSizeRegular};
  margin: 0;
`;
